import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 80px;
  background-color: var(--footer-color-sefaz);
  border-top: 2px solid var(--background-second-sefaz);
  position: fixed;
  bottom: 26px;
  color: var(--texto-contraste-color);
  font-size: 11px;
  padding: 10px;
  z-index: 2;
`;

export const RedesSociais = styled.div`
  float: left;
  a {
    margin: 2px 0 0 0;
  }
`;

export const Seguidores = styled.div`
  color: var(--texto-contraste-color);
  margin: 5px 0px;
  font-size: 10pt;
`;

export const Icon = styled.img`
  margin-right: 8px;
`;

export const Endereco = styled.div`
  float: right;
  text-align: right;
  font-size: 10pt;
  div {
    float: left;
  }
`;

export const Logo = styled.img`
  margin-left: 20px;
  height: 55px;
`;

export const Copy = styled.p`
  font-size: 8pt;
  margin-top: 5px;
`;

// VERSAO DATA

export const FooterWhite = styled.div`
  width: 100%;
  background-color: var(--background-second-sefaz);
  border-top: 2px solid var(--cinza-color);
  height: 27px;
  margin: 0 auto;
  margin-top: 2%;
  bottom: 0;
  position: fixed;
  padding-top: 2px;
  z-index: 2;
`;

export const Versao = styled.div`
  font-family: Calibri, Arial, Verdana;
  font-size: 11px;
  margin-left: 10px;
  display: flex;
`;

export const LocalData = styled.div`
  font-family: Calibri, Arial, Verdana;
  font-size: 12px;
  text-align: end;
  margin-right: 1%;
  margin-left: auto;
`;
